import { StorageKey } from './constants';

export const STORAGE_KEY = StorageKey.Global;

export type StorageType = 'session' | 'local';

class StorageProvider {
  private storageType: StorageType;
  private storage?: Storage;

  constructor(storageType: StorageType) {
    this.storageType = storageType;
    this.init();
  }

  init() {
    if (
      this.storageType === 'local' &&
      typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined'
    ) {
      this.storage = localStorage;
    }
    if (
      this.storageType === 'session' &&
      typeof window !== 'undefined' &&
      typeof window.sessionStorage !== 'undefined'
    ) {
      this.storage = sessionStorage;
    }
  }

  write<T>(key: string, value: T) {
    if (typeof this.storage === 'undefined') {
      return;
    }
    const existingData = this.storage.getItem(STORAGE_KEY);
    const storageData = {
      ...JSON.parse(existingData || '{}'),
      [key]: value,
    };
    return this.storage.setItem(STORAGE_KEY, JSON.stringify(storageData));
  }

  read<T = unknown>(key: string): T | undefined {
    if (typeof this.storage === 'undefined') {
      return;
    }
    const storageData = this.storage.getItem(STORAGE_KEY);
    if (!storageData) {
      return;
    }
    const data = JSON.parse(storageData);
    return data[key];
  }

  remove(key: string) {
    if (typeof this.storage === 'undefined') {
      return;
    }
    const storageData = this.storage.getItem(STORAGE_KEY);
    if (!storageData) {
      return;
    }
    this.storage.setItem(
      STORAGE_KEY,
      JSON.stringify(omit(JSON.parse(storageData || '{}'), key))
    );
  }
}

function omit(obj: any, key: string) {
  return Object.fromEntries(Object.entries(obj).filter(([k]) => k !== key));
}

export const local = new StorageProvider('local');

export const session = new StorageProvider('session');
